import { Col, Container } from '@microfrontends/react-components'
import SlideFamosPeople from '../../../components/NumerologyV2/SlideFamosPeople'
import Title from '../../../components/NumerologyV2/Title'
import {
	EPageTypeFamousPeople,
	IFamousPeople
} from '../../../services/numerology/@type'
import { Box, FamousPeopleCss } from '../Numerology.css'

export default function FamosPeole({
	famousPeople,
	isRobot
}: {
	isRobot: boolean
	famousPeople: IFamousPeople[]
}) {
	return (
		<Container>
			<FamousPeopleCss justify='center'>
				<Box className='center'>
					<Title
						title='số chủ đạo của người nổi tiếng'
						marker='triangle'
						backgound='oval'
					/>
				</Box>
				<Col>
					<SlideFamosPeople
						pageType={EPageTypeFamousPeople.HomePage}
						ssrFamousPeople={famousPeople}
						isRobot={isRobot}
					/>
				</Col>
			</FamousPeopleCss>
		</Container>
	)
}
